import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PlanFeature, PlanFeatureCreate, PlanFeatureFilter } from '../data/planFeature';

export function createPlanFeatureService(client: AxiosInstance) {
  return createCrudService<PlanFeature, PlanFeatureCreate, PlanFeatureFilter>(client, '/PlanFeature', 'planFeatureId');
}

export type PlanFeatureService = CrudService<PlanFeature, PlanFeatureCreate, PlanFeatureFilter>;
